import Api from '@/services/Api';

export default {
    fetchBlocks(id){
        return Api().get(`4.0/blocks/${id}`);
    },
}